export default {
  pageview: function (page, additionalFields = null) {
    if (additionalFields) {
      ga("send", Object.assign({
        hitType: "pageview",
        page: page
      }, additionalFields));
    } else {
      ga("send", "pageview", page);
    }
  }
}
